import { render, staticRenderFns } from "./HospitalSettings.vue?vue&type=template&id=2624b086&"
import script from "./HospitalSettings.vue?vue&type=script&lang=js&"
export * from "./HospitalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports